import { useRef } from 'react';
import { extractQueryDetails } from '../utils/extractQueryDetails';
import { usePromiseDataContext } from './promise-data-provider';

function useGetPromiseDataObj({ query }: { query: string }) {
  const promiseDataObjectsContext = usePromiseDataContext();
  const isExternalPromiseResolved = useRef(false);
  if (!promiseDataObjectsContext) {
    return null;
  }
  const { topLevelQueryKey } = extractQueryDetails(query);
  const prefetchedPromise =
    promiseDataObjectsContext?.getPromiseDataObject(topLevelQueryKey) || null;

  if (!isExternalPromiseResolved?.current && prefetchedPromise) {
    isExternalPromiseResolved.current = true;
    return prefetchedPromise;
  }

  return null;
}

export default useGetPromiseDataObj;
